"use client";
import { Box, Stack } from "@mui/material";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { Button } from "@/src/components/Button";

import { useHandleApiCall } from "../useHandleApiCall";
import { CustomErrorModalData, ErrorModalData } from "../types";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { useStepsNavigation } from "../useStepsNavigation";

// export const CustomErrorModal = ({
//   title,
//   description,
//   onCancel,
//   onSubmit,
// }: CustomErrorModalData) => {
//   const { runAction } = useHandleApiCall();

//   const onClose = () => {
//     runAction(onCancel);
//   };
//   const onSubmitClick = () => {
//     runAction(onSubmit);
//   };
//   return (
//     <Box className="flex w-full max-w-[524px] flex-col gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
//       <Stack className="flex flex-col gap-2 rounded-lg text-base text-dark-gray">
//         <Box className={"flex flex-col items-center justify-center gap-3"}>
//           <Box
//             className={
//               "flex aspect-square w-[68px] items-center justify-center rounded-full bg-[#FF00000D]"
//             }
//           >
//             <WebShopIcon name="triangle-alert" width={32} fill="#ff0000" />
//           </Box>
//           <Box className={"text-lg font-semibold text-dark-gray"}>{title}</Box>
//           <Box className={"text-center text-base text-dark-gray"}>
//             {description}
//           </Box>
//         </Box>
//       </Stack>
//       <Stack className="flex flex-col flex-nowrap gap-3 [&>*]:flex-1">
//         <Button variant={"outlined"} onClick={onClose}>
//           Мапа відділень
//         </Button>
//         <Button onClick={onSubmitClick}>Замовити консультацію</Button>
//       </Stack>
//     </Box>
//   );
// };

export const ErrorModal = ({
  title,
  description,
  cancelText = "Мапа відділень",
  submitText = "Замовити консультацію",
  buttonsLayout = "vertical",
  onCancel,
  onSubmit,
}: ErrorModalData) => {
   const { goBack, goNext, goToStep } = useStepsNavigation();
   const { handleApiCallByName } = useHandleApiCall();

   const handleCancel = () => {
     onCancel?.({
       nextStep: goNext,
       prevStep: goBack,
       specificStep: goToStep,
       handleApiCallByName
     });
   };
   const handleSubmit = () => {
     onSubmit?.({
       nextStep: goNext,
       prevStep: goBack,
       specificStep: goToStep,
       handleApiCallByName
     });
   };
  return (
    <Box className="flex w-full max-w-[524px] flex-col gap-6 rounded-xl bg-white p-6 shadow-xl center-modal max-md:animate-up-modal max-md:bottom-modal">
      <Stack className="flex flex-col gap-2 rounded-lg text-base text-dark-gray">
        <Box className={"flex flex-col items-center justify-center gap-3"}>
          <Box
            className={
              "flex aspect-square w-[68px] items-center justify-center rounded-full bg-[#FF00000D]"
            }
          >
            <WebShopIcon name="triangle-alert" width={32} fill="#ff0000" />
          </Box>
          <Box className={"text-lg font-semibold text-dark-gray"}>{title}</Box>
          <Box className={"text-center text-base text-dark-gray"}>
            {description}
          </Box>
        </Box>
      </Stack>
      <Stack
        className={cn(
          "flex flex-nowrap gap-3 [&>*]:flex-1",
          buttonsLayout === "vertical" ? "flex-col" : "flex-row",
        )}
      >
        {!!onCancel && (
          <Button variant={"outlined"} onClick={handleCancel}>
            {cancelText}
          </Button>
        )}
        {!!onSubmit && <Button onClick={handleSubmit}>{submitText}</Button>}
      </Stack>
    </Box>
  );
};
